import { render, staticRenderFns } from "./AmbitPlan.vue?vue&type=template&id=1925f29f&"
import script from "./AmbitPlan.vue?vue&type=script&lang=ts&"
export * from "./AmbitPlan.vue?vue&type=script&lang=ts&"
import style0 from "./AmbitPlan.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports